import { ReportDataResponse } from '../../../types/reportData.interface';
import { FullPageModule } from '../../../styles/global.styles';
import { ReactComponent as AssetLogo } from '../../../assets/images/assetLogo.svg';
import {
  BackCoverContainer,
  BackImageContainer,
  BackImageContent,
  CompanyInfo,
  CompanyName,
} from './cover.styles';

export const ReportBackCover = (props: ReportDataResponse) => {
  return (
    <FullPageModule>
      <BackCoverContainer>
        <BackImageContent>
          <BackImageContainer>
            {props.logo ? (
              <img src={props.logo} crossOrigin="anonymous" />
            ) : (
              <AssetLogo />
            )}
          </BackImageContainer>
          <CompanyName>{props.company || 'Company name'}</CompanyName>
          <CompanyInfo>
            <span>{props.address || 'Venture X Azca'}</span>
            <span>{props.city || 'Madrid'}</span>
            <span>{props.email || 'uda@udarealestate.com'}</span>
          </CompanyInfo>
        </BackImageContent>
      </BackCoverContainer>
    </FullPageModule>
  );
};
